var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-tabs', {
    staticClass: "routerTop",
    on: {
      "tab-click": _vm.goToPage
    },
    model: {
      value: _vm.dataMark,
      callback: function ($$v) {
        _vm.dataMark = $$v;
      },
      expression: "dataMark"
    }
  }, _vm._l(_vm.menuArr, function (item) {
    return _c('el-tab-pane', {
      key: item.dataMark,
      attrs: {
        "label": _vm.$t(`lang.${item.name}`),
        "name": item.dataMark
      }
    }, [item.dataMark == 'hmn' ? _c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(" " + _vm._s(_vm.$t(`lang.${item.name}`)) + " "), _c('svg', {
      staticClass: "icon",
      staticStyle: {
        "height": "12px",
        "width": "24px",
        "margin-bottom": "8px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": _vm.dataMark == 'hmn' ? '#icon-a-newselected' : '#icon-a-newunselected'
      }
    })])]) : _vm._e()]);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }